<div
  class="flex flex-column-reverse sm:flex-row w-full align-items-center"
  [ngClass]="justifyLeft ? 'justify-content-start' : 'justify-content-end'"
  data-cy="form-footer"
>
  <button
    *ngIf="!noCancel"
    pButton
    type="button"
    [label]="cancelLabel"
    class="p-button-outlined w-full mr-0 mt-3"
    [ngClass]="{ 'p-button-sm': small, 'sm:w-auto sm:mr-3 sm:mt-0': !fullWidthButtons }"
    (click)="handleCancel()"
    [disabled]="disabled"
    data-cy="cancel-button"
  ></button>
  <button
    pButton
    type="submit"
    [label]="submitLabel"
    class="w-full"
    [ngClass]="{ 'p-button-sm': small, 'sm:w-auto': !fullWidthButtons }"
    (click)="handleSubmit()"
    [attr.form]="formId"
    [disabled]="disabled"
    data-cy="submit-button"
  ></button>
</div>
